"use client";
import { useEffect, useState } from "react";

export const useCurrencyPrice = (price, currency) => {
  const [formattedPrice, setFormattedPrice] = useState("");

  useEffect(() => {
    switch (currency) {
      case "USD":
        setFormattedPrice("$" + Math.ceil(price / 1.7));
        break;
      case "AZN":
        setFormattedPrice("₼" + price);
        break;
      default:
        setFormattedPrice("₼" + price);
        break;
    }
  }, [price, currency]);

  return formattedPrice;
};
